import { replaceUrlParam } from "../../ui/utils/location";

export const getBrand = state => state.brand.data;
export const isBrandFetching = state => state.brand.isFetching;
export const getBrandKey = state => state.brand.brandKey;
export const getBridgeBrand = state =>
  getBrandValue(state, "Bridge.bridgeBrand");

export const getBrandValue = (state, key, fallback) => {
  const data = getBrand(state);
  const keys = key.split(".");
  return keys.reduce((acc, key) => {
    if (acc === undefined) {
      // Key likely doesn't exist
      return fallback;
    } else if (typeof acc === "object") {
      return acc[key] !== undefined && acc[key] !== null ? acc[key] : fallback;
    } else {
      return acc;
    }
  }, data);
};

export const shouldShowOnboarding = state => {
  const brand = getBrand(state);
  return (
    brand.Onboarding &&
    (brand.Onboarding.enabled ||
      brand.Onboarding.custom.some(card => card.enabled))
  );
};

export const shouldAutoShowOnboarding = (state, auto = false) => {
  const brand = getBrand(state);
  return (
    brand.Onboarding &&
    (auto ||
      brand.Onboarding.autoOpen ||
      brand.Onboarding.custom.some(card => card.force))
  );
};

export const shouldForceShowOnboarding = state => {
  const brand = getBrand(state);
  return brand.Onboarding && brand.Onboarding.custom.some(card => card.force);
};

export const isBookshelfBrand = state => {
  const brand = getBrand(state, "brand");
  return brand === "Bookshelf Online";
};

export const isVitalSoureBrand = state => {
  return getBrandValue(state, "vstBrand", false);
};

export const bannerAdsEnabled = state => {
  return getBrandValue(state, "Store.showBannerAds", false);
};

/**
 * @deprecated
 * @see getStoreProductUrl
 * Expected to be removed/replaced as part of new expired book features
 * URLs/params seem off in current use cases, don't want to destabilize/retest code though
 */
export const storeProductsUrl = (state, isbn = "expired-notification") => {
  const utm_medium = "expired-notification";
  let store = getBrandValue(
    state,
    "Store.url",
    `https://www.vitalsource.com?utm_source=Bookshelfonline&utm_medium=${utm_medium}&utm_campaign=${
      isbn || utm_medium
    }`
  );
  const qIndex = store.lastIndexOf("?");
  if (qIndex >= 0) {
    store = `${store.substr(0, qIndex)}/products${store.substr(qIndex)}`;
  }
  store = replaceUrlParam(store, "utm_campaign", isbn);
  store = replaceUrlParam(store, "utm_medium", utm_medium);
  store = replaceUrlParam(store, "term", isbn);
  store = replaceUrlParam(store, "renewal", true);

  return store;
};

const makeVstStoreUrl = (state, subpath, params = {}) => {
  const isEnabled = getBrandValue(state, "Store.enabled", true);
  const isVstStore = getBrandValue(state, "Store.vstStore", true);

  if (isEnabled && isVstStore) {
    const storeUrlStr = getBrandValue(
      state,
      "Store.url",
      "https://www.vitalsource.com"
    );
    const storeUrlObj = new URL(storeUrlStr);
    // Allow append to e.g. https://www.vitalsource.com/mx/, with or without trailing slash
    storeUrlObj.pathname = `${storeUrlObj.pathname}${subpath}`.replace(
      "//",
      "/"
    );
    storeUrlObj.searchParams.set("utm_source", "bookshelfonline");
    storeUrlObj.searchParams.set("source", "bookshelf");
    Object.keys(params).forEach(param => {
      const value = params[param];
      if (value !== undefined) {
        storeUrlObj.searchParams.set(param, params[param]);
      }
    });
    return storeUrlObj.toString();
  }
};

// Get the branded store url, append utm params if needed
export const getBrandedStoreUrl = (state, utmParams = {}) => {
  return (
    makeVstStoreUrl(state, "/", utmParams) ||
    getBrandValue(state, "Store.url", "https://www.vitalsource.com/")
  );
};

export const getBrandedCustomButtonUrl = (state, utmParams = {}) => {
  const isVstStore = getBrandValue(state, "Store.vstStore", true);
  const isAppsStoreEnabled = getBrandValue(state, "Store.enabled", true);
  const customButtonUrlStr = getBrandValue(
    state,
    "Header.CustomButton.url",
    "https://www.vitalsource.com/"
  );
  const storeUrlStr = getBrandValue(
    state,
    "Store.url",
    "https://www.vitalsource.com"
  );

  if (isAppsStoreEnabled && isVstStore && customButtonUrlStr === storeUrlStr) {
    return makeVstStoreUrl(state, "/", utmParams);
  }

  return customButtonUrlStr;
};

export const getStoreProductUrl = (state, isbn, params = {}) => {
  return makeVstStoreUrl(state, "/show/" + isbn, {
    ...params,
    term: isbn
  });
};

export const getStoreProductRenewalUrl = (state, isbn, params = {}) => {
  return getStoreProductUrl(state, isbn, {
    ...params,
    renewal: true
  });
};

export const getStoreSearchUrl = (state, searchTerm, utmParams = {}) => {
  return makeVstStoreUrl(state, "/textbooks", {
    ...utmParams,
    term: searchTerm
  });
};

export const brandHasSwimlanes = state => {
  return (
    getBrandValue(state, "Subscriptions.Swimlanes.added", false) ||
    getBrandValue(state, "Subscriptions.Swimlanes.licensed", false) ||
    getBrandValue(state, "Subscriptions.Swimlanes.popular", false) ||
    getBrandValue(state, "Subscriptions.Swimlanes.recommended", false) ||
    getBrandValue(state, "Subscriptions.Swimlanes.subjects", false)
  );
};
